import React, { useState } from "react";

const TextfieldComponent = ({
  label,
  id,
  type,
  name,
  value,
  onChange,
  onFocus,
  disabled = false,
  prefix,
  error,
  required,
  fontsize,
  min,
  max,
  step,
  placeholder
}) => {
  const errorMsg = error
  return (
    <div className="UI-form-group tw-pb-1">
      <label className={"UI-label"} style={{color:errorMsg && "red", fontSize:fontsize}}>{label}{required && <sup>*</sup>}</label>
      <div
        style={{
          position: "relative",
        }}
      >
        <input
          type={type || "text"}
          id={id}
          name={name}
          className={`UI-input ${prefix && " !tw-pr-14 "} ${disabled && " !tw-border-dashed !tw-bg-[#f3f4f6] "} ${errorMsg ? " !tw-border-red-500 " : " focus:!tw-border-blue-500 "} `}
          min={min}
          max={max}
          step={step}
          value={value}
          onChange={onChange}
          onFocus={onFocus}
          placeholder={placeholder}
          disabled={disabled}
          style={{
            width: "100%",
            // paddingRight: prefix && "55px",
            // borderStyle:disabled && "dashed",
            // backgroundColor: disabled && "#f3f4f6",
            // borderColor:errorMsg?"red":focus && "#3574de",
            fontSize:fontsize
          }}
        />
       {prefix &&  <span
          style={{
            position: "absolute",
            right: "12px",
            top: "50%",
            transform: "translateY(-50%)",
            pointerEvents: "none",
            fontSize: fontsize,
            color: "#666",
          }}
        >
          {prefix}
        </span>}
      </div>
      {errorMsg && <div>
        <p className="tw-text-[10px] tw-text-[#ff0000] m-0 tw-pt-0.5 tw-pl-1">{errorMsg}</p>
      </div>}
    </div>
  );
};

export default TextfieldComponent;
